//
import React from 'react';
import {
  ActivityIndicator,
  ScrollView,
  StyleProp,
  StyleSheet,
  useWindowDimensions,
  View,
  ViewStyle
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import colors from '../../colors';
import { SIDE_PADDING, TOP_PADDING, MAX_WIDTH } from '../../constants';
import { useIsBigScreen, conditionalStyle } from '../../helper';
import { useAlert } from '../../redux/alert/alertHooks';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import ApresentacaoEmpresa from '../ProdutosPage/ApresentacaoEmpresa';
import AlertDialog from './AlertDialog';
// import { useSnack } from '../../redux/snack/snackHooks';

// const ReduxLoader = (props) => {

//   return props.children;
// };

type Props = {
  scrollView?: boolean;
  header?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  padding?: boolean;
  loading?: boolean;
};

const PageContainer: React.FC<Props> = (props) => {
  const { scrollView, header, style, containerStyle, padding, loading } = props;
  const [mostrarAlert, fecharAlert, alert] = useAlert();

  const dimensions = useWindowDimensions();
  const isBigScreen = useIsBigScreen();

  const [empresa] = useEmpresa();

  const paddingStyle = {
    padding: padding === false || scrollView === true ? 0 : SIDE_PADDING
  };

  if (!empresa || loading) {
    return (
      <SafeAreaView style={[containerStyle, styles.loadingView]}>
        <ActivityIndicator size={100} color={colors.primary} />
      </SafeAreaView>
    );
  }

  if (scrollView === false) {
    return (
      <SafeAreaView
        style={[{ flex: 1, backgroundColor: '#fff', maxHeight: dimensions.height }, containerStyle]}
      >
        {header}
        <View style={[{ flex: 1 }, style]}>
          <AlertDialog
            titulo={alert.titulo}
            descricao={alert.mensagem}
            show={alert.show}
            onClose={fecharAlert}
            actions={alert.actions}
          />

          <View style={{ flex: 1 }}>
            <View style={{ flex: 1 }}>{props.children}</View>
          </View>
        </View>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={[{ flex: 1, backgroundColor: '#fff', maxHeight: dimensions.height }]}>
      {header}
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={[conditionalStyle(isBigScreen, styles.contentBig), containerStyle]}
        keyboardShouldPersistTaps={'always'}
      >
        <View style={[paddingStyle, style]}>
          <AlertDialog
            titulo={alert.titulo}
            descricao={alert.mensagem}
            show={alert.show}
            onClose={fecharAlert}
            actions={alert.actions}
          />

          <View style={{ flex: 1 }}>
            <View style={{ flex: 1 }}>{props.children}</View>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: { flexDirection: 'row', justifyContent: 'space-around', alignItems: 'flex-start' },
  contentBig: {
    width: MAX_WIDTH,
    alignSelf: 'center'
  },
  loadingView: {
    flex: 1,
    backgroundColor: '#fff',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

export default PageContainer;
